import { jsx as _jsx } from "react/jsx-runtime";
import { RouteKeys } from '@/configs';
import { createShareUrl } from '@/lib';
import classnames from 'classnames';
import { useCallback } from 'react';
import { Icon } from '../Icon';
import { useLocales } from '../useLocales';
import styles from './index.module.less';
export const SNSShare = ({ className, chainId, boxId, boxName, rootHash, ...rest }) => {
    const t = useLocales();
    const twText = t('sns-share-to-twitter', {
        boxName,
        link: `${location.origin}/#${RouteKeys.Details}?chain=${chainId}&box=${boxId}&rootHash=${rootHash}`,
    });
    const handleShareToTwitter = useCallback(() => {
        const shareLink = createShareUrl(twText);
        window.open(shareLink, 'noopener noreferrer');
    }, [twText]);
    return (_jsx("div", { className: classnames(styles.snsShare, className), ...rest, children: _jsx(Icon, { type: "twitter", className: styles.button, role: "button", onClick: handleShareToTwitter }) }));
};
